export const isElementInViewUtil = (el, targetRect = {
    top: 0,
    left: 0,
    right: window.innerWidth,
    bottom: window.innerHeight,
}) => {
    const rect = el.getBoundingClientRect();
    return (Math.round(rect.top) >= Math.round(targetRect.top) &&
        Math.round(rect.left) >= Math.round(targetRect.left) &&
        Math.round(rect.bottom) <= Math.round(targetRect.bottom) &&
        Math.round(rect.right) <= Math.round(targetRect.right));
};
export default isElementInViewUtil;
